import { render, staticRenderFns } from "./SchoolLayout.vue?vue&type=template&id=7c2252b1&scoped=true"
import script from "./SchoolLayout.vue?vue&type=script&lang=js"
export * from "./SchoolLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2252b1",
  null
  
)

export default component.exports